import { Card } from 'types/card'

// TrainingModules
export enum ActivityType {
  TrainingModules = 'elearning',
  PocketGuides = 'pocket-guides',
  TrainingVideos = 'videos',
  DistanceCourses = 'distance-courses',
  RapidElearning = 'rapid-elearning',
  Surveys = 'pulse-surveys',
}

export type TrainingLibraryOverview = {
  rootCategories: Card[]
  distanceCoursesCount: number
  elearningsCount: number
  pocketGuidesCount: number
  rapidElearningsCount: number
  surveysCount: number
  videosCount: number
}

// Api Response
export type ApiTrainingLibraryDataResponse = {
  overview: TrainingLibraryOverview
}
